import { format } from 'date-fns'
import * as React from 'react'
import 'react-calendar/dist/Calendar.css'

import {
  FieldWrapper,
  FieldWrapperProps,
} from 'components/FieldWrapper/FieldWrapper'

import { ReactComponent as CalendarIcon } from 'assets/images/svg/calendar.svg'

import styles from './TextFieldCalendar.module.scss'
import {
  ChangeCalendarFormValues,
  TextFieldCalendarModal,
} from './TextFieldCalendarModal'

interface Props extends FieldWrapperProps {
  onChangeDate?(
    date: Omit<ChangeCalendarFormValues, 'date'> & {
      date: string
    },
  ): void
  defaultValues?: ChangeCalendarFormValues
}

export const TextFieldCalendar: React.FC<Props> = ({
  onChangeDate,
  defaultValues,
  ...props
}) => {
  const [values, setValues] = React.useState<ChangeCalendarFormValues>(
    defaultValues || {
      date: null,
      hour: null,
      minute: null,
    },
  )
  const [visible, setVisible] = React.useState(false)
  const changeDate = (values: ChangeCalendarFormValues) => {
    setValues(values)
    onChangeDate?.({
      ...values,
      date: format(values.date as Date, 'yyyy-MM-dd'),
    })
  }
  const openModal = () => {
    setVisible(true)
  }
  const closeModal = () => {
    setVisible(false)
  }
  const dateText = () => {
    if (!values.date) {
      return ''
    }

    const date = format(values.date, 'dd.MM.yyyy')
    const hour = `0${values.hour}`.slice(-2)
    const minutes = `0${values.minute}`.slice(-2)
    return `${date} ${hour}:${minutes}`
  }
  return (
    <FieldWrapper {...props}>
      <div onClick={openModal} className={styles.container}>
        <div className={styles.text}>{dateText()}</div>
        <div className={styles.icon}>
          <CalendarIcon />
        </div>
      </div>
      {visible ? (
        <TextFieldCalendarModal
          title={props.label as string}
          defaultValues={values}
          onAccept={changeDate}
          onClose={closeModal}
        />
      ) : null}
    </FieldWrapper>
  )
}
